import { createFileRoute } from '@tanstack/react-router';
import dayjs from 'dayjs';

import IconSkinCheck from 'src/assets/icons/icon-skincheck.svg';
import HeaderActions from 'src/components/skincheck-result/HeaderActions';
import SkinCheckReports from 'src/components/skincheck-result/SkinCheckReports';
import PageHeader from 'src/components/ui/page-header';

export const Route = createFileRoute('/skincheck-result')({
  component: RouteComponent,
});

function RouteComponent() {
  const skincheckDate = new Date();

  return (
    <div>
      <div className="bg-gradient-to-r from-[#F7EDE2] to-[#ECE1F0]">
        <PageHeader
          title="Skin Check Result"
          backHref="/camera"
          rightActions={<HeaderActions />}
          className="bg-gradient-to-r from-[#F7EDE2] to-[#ECE1F0]"
        />
        <div className="flex items-center justify-between p-6">
          <div className="flex gap-2">
            <IconSkinCheck />
            Skin Check
          </div>
          <span>
            {dayjs(skincheckDate).format('HH:mm')} • {dayjs(skincheckDate).format('DD/MM/YYYY')}
          </span>
        </div>
        <SkinCheckReports />
      </div>
    </div>
  );
}
